import React from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { gql } from '@apollo/client'
import { Loading } from '@website2018/da-dobsonville'
import NewsroomTemplate from '../../components/Newsroom/NewsroomTemplate'

class NewsroomContainer extends React.Component {
  render() {
    const { loading, error } = this.props

    if (loading) return <Loading />
    if (error) return <p>{error}</p>

    return <NewsroomTemplate {...this.props} />
  }
}

const TEMPLATE_QUERY = gql`
  query getTemplate($slug: String) {
    page(slug: $slug) {
      id
      slug
      seo
      title {
        rendered
      }
      content {
        rendered
      }
      excerpt {
        rendered
      }
      hero {
        headline
        background_image {
          url
        }
        focus_point
      }
    }
    videos {
      id
      videoId
      title {
        rendered
      }
      excerpt {
        rendered
      }
      category {
        id
        name
      }
      featured_media {
        id
        source_url
        title {
          rendered
        }
      }
    }
  }
`

const withTemplate = graphql(TEMPLATE_QUERY, {
  options: () => ({
    variables: {
      slug: 'newsroom'
    }
  }),
  props: ({ data }) => ({ ...data })
})

export default withTemplate(NewsroomContainer)
